<div class="cardModal">
    <div class="cardTitle">
        <h3>
            {{ 'listings.userPreferences.title' | translate }}
        </h3>
    </div>

    <div class="cardContentStretched">
        <app-tab-outline class="listingUserPreferencesTabs" [tabs]="tabs()" [(selectedTabIndex)]="selectedTabIndex" #tabOutlineComponent>
        </app-tab-outline>
    </div>
</div>
